import * as types from './mutation-types'

export default {
  savePhfood({ commit }, plan) {
    commit(types.SAVE_PHFOOD, plan);
  },
  deletePhfood({ commit }, plan) {
    commit(types.DELETE_PHFOOD, plan)
  },
  phAddWeight({ commit }, objadd) {
    commit(types.PH_ADD_WEIGHT, objadd)
  },
  saveGisFood({ commit }, plan) {
    commit(types.SAVE_GIS_FOOD, plan);
  },
  deleteGisFood({ commit }, plan) {
    commit(types.DELETE_GIS_FOOD, plan)
  },
  gisAddWeight({ commit }, objadd) {
    commit(types.GIS_ADD_WEIGHT, objadd)
  },
  saveCarboFoodBefore({ commit }, plan) {
    commit(types.SAVE_CARBO_FOOD_BEFORE, plan);
  },
  deleteCarboFoodBefore({ commit }, plan) {
    commit(types.DELETE_CARBO_FOOD_BEFORE, plan)
  },
  carbobeforeAddWeight({ commit }, objadd) {
    commit(types.CARBOBEFORE_ADD_WEIGHT, objadd)
  },
  saveCarboFoodAfter({ commit }, plan) {
    commit(types.SAVE_CARBO_FOOD_AFTER, plan);
  },
  deleteCarboFoodAfter({ commit }, plan) {
    commit(types.DELETE_CARBO_FOOD_AFTER, plan)
  },
  carboafterAddWeight({ commit }, objadd) {
    commit(types.CARBOAFTER_ADD_WEIGHT, objadd)
  }
};


// WEBPACK FOOTER //
// ./src/store/actions.js